import { FormPagePropertyItemMailRefusalFlag } from 'backend';
import { MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE } from 'shared';
import { PropertyItemElement } from '..';

export const getMailRefusalFlagPropertyItemElementFormCustomize = (
  propertyItem: FormPagePropertyItemMailRefusalFlag,
): PropertyItemElement => {
  switch (propertyItem.inputFormat?.inputType) {
    case MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE.radio: {
      const radios = document.querySelectorAll<HTMLElement>(
        `input[type="radio"][data-nform-property-id="${propertyItem.propertyId}"]`,
      );
      if (radios.length == 0) {
        return {};
      }
      return {
        radios: Array.from(radios),
      };
    }
    default: {
      return {};
    }
  }
};
